export default __webpack_public_path__ + "static/media/your-goals.b096c33c.svg";